import API from "./api"

export default function useRemoveDealComparableDeals({ deal }) {
  return async (comparable_deals) => {
    const removePromises = comparable_deals.map((comparable_deal) =>
      API.delete(`deals/${deal.id}/sales/${comparable_deal.id}`)
    )

    await Promise.all(removePromises)
  }
}
